import debounce from 'lodash/debounce'

function animateLazyImages() {
    const imageEls = [
        ...document.querySelectorAll('img[loading="lazy"]:not(.is-loading):not(.is-loaded)'),
    ]
    imageEls.forEach(imageEl => {
        const reveal = () => {
            clearTimeout(antiTimer)
            imageEl.classList.remove('is-loading')
            imageEl.classList.add('is-loaded')
        }

        const antiTimer = setTimeout(() => {
            reveal()
        }, 3000)

        if (imageEl.complete) {
            reveal()
        } else {
            imageEl.classList.add('is-loading')
            imageEl.addEventListener('load', reveal, { once: true })
        }
    })
}

export function runLazyImages(target = document.documentElement || document.body) {
    const debouncedAnimateLazyImages = debounce(animateLazyImages, 100)

    const observer = new MutationObserver(() => {
        debouncedAnimateLazyImages()
    })

    observer.observe(target, {
        attributes: false,
        childList: true,
        subtree: true,
        characterData: false,
    })
}
